/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, FormControlLabel, FormGroup, Icon, IconButton, LinearProgress, Switch, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { errorNotify, successNotify } from '../../../utils/helper';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { setAllRolesList } from '../../../redux/slices/roles/roles';
import Table from '../../../components/table/Table';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import InputControl from '../../../components/input/InputControl';
import { colors } from '../../../utils';
import { endPoints } from '../../../api/apiEndpoints';
import { setAllUsers } from '../../../redux/slices/users/users';
import { Api } from '../../../api/api';
import Card from '../../../components/layout/Card';

const styles = {
	card: {
		padding: "2rem",
		border: "none",
		boxShadow: "none",
		width: "90%"
	}
}
const Users = (props) => {
	const { companyDetails } = props
	const dispatch = useDispatch();
	const { colorWhite, colorPrimary, colorGreenGradient } = colors;
	const { users } = useSelector((state) => state?.users);
	const { rolesList } = useSelector((state) => state?.roles);
	const { clientId } = useSelector((state) => state?.activeAccount);
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});
	const [openModal, setOpenModal] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingSubmitting, setIsLoadingSubmitting] = useState(false);
	const [isAdmin, setIsAdmin] = useState(false);
	const [originalData, setOriginalData] = useState(null);

	const [formData, setFormData] = useState({
		username: '',
		password: '',
		email: '',
		number: '',
		// position: '',
		// role: '',
		enabled: false,
	});

	const handleCloseModal = () => {
		setIsEditing(false)
		setOpenModal(false)
		setFormData({ username: '', password: '', email: '', number: '' })

	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};
	const handleChangeSwitch = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.checked,
		}));
	};

	const handleEditModal = (val) => {
		setIsEditing(true)
		setOpenModal(val)
		setFormData({ id: val.id, uuid: val.uuid, username: val.username, password: val.password, email: val.email, number: val.number, enabled: val.enabled });
		setOriginalData({ id: val.id, uuid: val.uuid, username: val.username, password: val.password, email: val.email, number: val.number, enabled: val.enabled });
		setIsAdmin(val?.max_token_count == -1 ? true : false);
	};

	const column = [
		{
			title: '#',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		{
			title: 'User Name',
			field: 'username',
			render: (rowData) => <h4 className='font-face-B'>{rowData?.username}</h4>,
		},
		{
			title: 'Email',
			field: 'email',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.email}</h4>,
		},
		{
			title: 'Number',
			field: 'number',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.number}</h4>,
		},
		{
			title: 'enabled',
			field: 'enabled',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.enabled ? <Icon color='success' className="text-green text-16">check_circle</Icon> : <Icon className="text-red text-16">cancel</Icon>}</h4>,
		},
		{
			title: 'edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => handleEditModal(rowData)} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},

	];

	const getAllUsers = async (lim, pg) => {
		setIsLoading(true)
		try {
			const response = await Api?.post(endPoints?.users?.list, {
				"client_id": 0,
				"limit": lim || 10,
				"page": pg || 1
			}, {
				headers: {
					'xt-user-token': null
				}
			});
			dispatch(
				setAllUsers(
					response?.data?.data?.agentList?.map((d, index) => ({
						index: index + 1,
						id: d?.id,
						uuid: d?.uuid,
						username: d?.username,
						email: d?.email,
						number: d?.number,
						position: d?.position,
						enabled: d?.enabled,
						role: d?.roles[0],
						max_token_count: d?.max_token_count,
					})
					),
				),
			);
			const { page, limit, totalPages, totalRecords } = response?.data?.data?.pagination;
			setCurrentParams({ page, limit, totalPages, totalRecords });
			setIsLoading(false)

		} catch (error) {
			setIsLoading(false)

		}
	};
	const getRoles = async () => {
		try {

			await Api.post(endPoints?.roles?.get, {
				"limit": 10,
				"page": 0,
				"columns": "*",
				"sortby": "ASC",
				"orderby": "id",
				"where": "displayed = $1",
				"values": true
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllRolesList(
							response?.data?.data?.list?.data?.map((d, index) => ({
								id: d?.id,
								description: d?.name,
							})
							),
						),
					);
				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {

			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};
	useEffect(() => {
		getAllUsers();
		getRoles();
	}, [])

	const handleSubmit = async () => {
		if (isEditing) {
			setIsLoadingSubmitting(true);
			try {

				const changedFields = {};
				Object.keys(formData).forEach(key => {
					if (formData[key] !== originalData[key]) {
						changedFields[key] = formData[key];
					}
				});
				// Always send required fields for update
				changedFields.role = 65;
				changedFields.position = "";
				changedFields.clientId = 0;
				changedFields["max_token_count"] = isAdmin ? -1 : 1;


				await Api?.put(`${endPoints?.users?.update}/${formData.uuid}`, {
					// ...formData,
					// role: 65,
					// position: "",
					// clientId: 0,
					// "max_token_count": isAdmin ? -1 : 1,
					...changedFields,

				}, {
					headers: {
						'xt-user-token': null
					}
				});
				handleCloseModal();
				setIsLoadingSubmitting(false);
				successNotify("User Updated Successfully")
				getAllUsers();



			} catch (error) {
				setIsLoadingSubmitting(false);
				if (error?.response?.data) {
					errorNotify(error?.response?.data?.message);
				}
			}

		} else {

			try {

				if (formData.username !== "" && formData.password !== "" && formData.email !== "" && formData.number !== "") {
					setIsLoadingSubmitting(true);

					const response = await Api?.post(endPoints?.users?.create, {
						...formData,
						"max_token_count": isAdmin ? -1 : 1,
						"default_receiver": true,
						clientId: 0,
						role: 65,
						position: ""
					}, {
						headers: {
							'xt-user-token': null
						}
					});
					successNotify("User Added Successfully");
					setIsLoadingSubmitting(false);
					handleCloseModal();
					getAllUsers();
				} else {
					setIsLoadingSubmitting(false);
					errorNotify('Please Fill All Fields');

				}

			} catch (error) {
				setIsLoadingSubmitting(false);
				if (error?.response?.data?.message) {
					errorNotify(error.response.data.message);
				} else {
					errorNotify("An unexpected error occurred. Please try again.");
				}
			}
		}
	};
	return (
		<>
			<Card margin='3rem 1.5rem' padding='3rem'>
				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom btnTitle='Add User' onClickHandler={() => setOpenModal(true)} />
				</Flex>
				<TransitionsModal
					open={openModal}
					// handleOpen={handleOpenModal}
					handleClose={handleCloseModal}
					modalTitle={isEditing ? 'Update User' : 'Create User'}
				// submitHandler={leaveApprovedHandler}
				// submitDisabledBtn={leaveApprovedDis}
				>
					<Grid gtc='repeat(auto-fit, minmax(35rem, 1fr))' margin='2.5rem 0' padding='2rem'>

						<MarginHandler width='100%'>
							<InputControl
								state={formData?.username}
								onChange={handleChange}
								label='User Name'
								name='username'
								required
							/>
						</MarginHandler>
						<MarginHandler width='100%'>
							<InputControl
								state={formData?.password}
								onChange={handleChange}
								label='Password'
								name='password'
								type={"password"}
								required
							/>
						</MarginHandler>
						<MarginHandler width='100%'>
							<InputControl
								state={formData?.email}
								onChange={handleChange}
								label='Email'
								name='email'
								type={"email"}
								required
							/>
						</MarginHandler>
						<MarginHandler width='100%'>
							<InputControl
								state={formData?.number}
								onChange={handleChange}
								label='Number'
								name='number'
								type={"number"}
								required
							/>
						</MarginHandler>
						{/* <MarginHandler width='100%'>
							<InputControl
								state={formData?.position}
								onChange={handleChange}
								label='Position'
								name='position'
							/>
						</MarginHandler> */}

						{/* <MarginHandler>
							<FilledSelectOption
								label='Role'
								state={formData?.role}
								onChange={handleChange}
								options={rolesList}
								// maxWidth='10rem'
								width='16rem'
								minWidth='14rem'
								// minWidth='100%'
								name='role'
							/>
						</MarginHandler> */}


						<MarginHandler width='100%'>
							<FormGroup>
								<FormControlLabel control={<Switch onChange={handleChangeSwitch} checked={formData?.enabled} name='enabled' />} label="Enable" />
							</FormGroup>
						</MarginHandler>
						<MarginHandler width='100%'>
							<FormGroup>
								<FormControlLabel control={<Switch onChange={(e) => setIsAdmin(e.target.checked)} checked={isAdmin} name='isAdmin' />} label="Is Admin" />
							</FormGroup>
						</MarginHandler>

						<MarginHandler mt="2rem">
							<Button
								color='primary'
								variant='contained'
								onClick={handleSubmit}
								style={{
									background: colorGreenGradient,
									fontSize: '1.6rem',
									textTransform: 'none',
									padding: '0.7rem 2rem',
									color: colorWhite,
									borderRadius: '0.5rem',
									// float:"right"
								}}
								disabled={isLoadingSubmitting}
								className='font-face-R'>
								Submit
							</Button>
						</MarginHandler>

					</Grid>
				</TransitionsModal>

				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={users?.map((item) => ({ ...item }))}
						sorting
						// search
						// filtering
						columnsButton
						showTitle
						paginationType='normal'
						titleHeading='Users'
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getAllUsers(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getAllUsers(currentParams.limit, newPage + 1)}
						curPage={currentParams.page - 1}
					/>
				}
			</Card>
		</>
	);
};

export default Users;
